;
define("store_locator_results.tpl", function(){});

